import { Navigate, Outlet, matchPath, useLocation } from 'react-router-dom';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import {
  NBA_S3_PLAY_COMMON_MARKET,
  NBA_S3_PLAY_COMMON_MARKET_ADD_CARD,
} from '@sorare/core/src/constants/__generated__/routes';

import { CommonMarketHeader } from '@sorare/marketplace/src/components/commonCard/CommonMarketHeader';

const NBACommonMarketLayout = () => {
  const location = useLocation();
  if (matchPath(location.pathname, NBA_S3_PLAY_COMMON_MARKET)) {
    return <Navigate to={NBA_S3_PLAY_COMMON_MARKET_ADD_CARD} />;
  }
  return (
    <ContentWithStickyHeader header={<CommonMarketHeader />}>
      <Outlet />
    </ContentWithStickyHeader>
  );
};

export default NBACommonMarketLayout;
